import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=6419eb8a&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&id=6419eb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6419eb8a",
  null
  
)

export default component.exports